<div class="cbm-header d-print-none" *ngIf="!!activeModal">
  <h4 class="cbm-title">{{'Continuous Booking'|translate}}</h4>
  <span class="cbm-count">{{'Selected days'|translate}}: <b>{{numberOfDtes}}</b></span>
  <button type="button" class="cbm-close" aria-label="Close" (click)="close()">&#10005;</button>
</div>
<div appContinuosModal class="modal-body cbm-body d-print-none pb-0 pt-0">
  <div class="loading" *ngIf="loading"></div>

  <form autocomplete="off">
    <!-- one flex row, every control (count input, both date pickers, submit)
         shares the same 38px height — the old bootstrap cols mixed
         form-control-sm inputs with [small] pickers and mismatched heights -->
    <div class="cbm-controls">
      <div class="cbm-field cbm-count-field">
        <label class="cbm-label">{{'Available'|translate}} {{'days'|translate}}</label>
        <input class="form-control cbm-control" type="floatNumber" tabindex="-1" #totalInput
          (click)="onFocus($event)" (focus)="onFocus($event)" [formControl]="totalFormControl" name="total"
          (input)="countSubject.next($event.target.value)" [class.disabled]="!!quantity">
      </div>
      <div class="cbm-field" [ngClass]="{ 'has-danger' : (!!message) }">
        <label class="cbm-label">{{'From Date'|translate}}</label>
        <!-- app-date-picker [static]: inline calendar (the old <datetime>
             bsDatepicker popup rendered detached at the screen corner
             inside this modal). dayjs <-> Date bridged in the component. -->
        <app-date-picker [static]="true" [ngModel]="fromDateDayjs" (ngModelChange)="onFromDatePicked($event)"
          [minDate]="fromMinDate" [maxDate]="pickerMaxDate" placeholder="dd-mm-yyyy"
          [ngModelOptions]="{standalone: true}"></app-date-picker>
        <small class="text-danger" *ngIf="!!message">
          {{message}}
        </small>
      </div>
      <div class="cbm-field" [ngClass]="{ 'has-danger' : (!!message) }">
        <label class="cbm-label">{{'To Date'|translate}}</label>
        <app-date-picker [static]="true" [ngModel]="toDateDayjs" (ngModelChange)="onToDatePicked($event)"
          [minDate]="toMinDate" [maxDate]="pickerMaxDate" placeholder="dd-mm-yyyy"
          [ngModelOptions]="{standalone: true}"></app-date-picker>
      </div>
      <div class="cbm-field cbm-submit-field">
        <label class="cbm-label">&nbsp;</label>
        <button class="cbm-submit" type="button" [appFocusAlways]=true
          (click)="continuosBooking()">{{'Submit'|translate}}</button>
      </div>
    </div>
    <div class="form-check"  (click)="$event.stopPropagation()">
      <input class="form-check-input" type="checkbox" id="same_address" [checked]="isPradosham===true" (click)="onPradoshamChange(!isPradosham)">
      <label class="form-check-label" for="same_address">Pradosham</label>
    </div>
    <!-- Div-grid virtual table (pooja-enquiry-v2 pattern): a sticky header
         (labels + the filter row) above a cdk-virtual-scroll-viewport whose
         rows share the same grid columns. Same bindings/pipes as the old
         <table> — presentation-only restructure. -->
    <div class="cb-table" *ngIf="!!displaypanEvents?.length">
      <div class="cb-row cb-head-row">
        <span class="cb-cell cb-check">
          <span class="form-check" (click)="$event.stopPropagation()">
            <input class="form-check-input" type="checkbox" [checked]="checkbox===true" (click)="check()"
              title="{{'All'|translate}}">
          </span>
        </span>
        <span class="cb-cell">{{'Date'|translate}}</span>
        <span class="cb-cell">{{'Month'|translate}}</span>
        <span class="cb-cell">{{'Star'|translate}}</span>
        <span class="cb-cell">{{'Thithi'|translate}}</span>
        <span class="cb-cell">{{'Week'|translate}}</span>
      </div>
      <div class="cb-row cb-filter-row" *ngIf="!isPradosham">
        <span class="cb-cell cb-check"></span>
        <span class="cb-cell">
          <app-auto-complete (ngModelChange)="monthChangeSub.next($event);" [settings]="autoCompleteSettings"
            [(ngModel)]="enMonth" [options]="allEnMonths" [ngModelOptions]="{standalone: true}">
          </app-auto-complete>
          <select *ngIf="!!isMonthFilter" [(ngModel)]="monthOption" [ngModelOptions]="{standalone: true}"
            class="form-select form-select-sm" (change)="panchangFilter(enMonth,'enMonth')">
            <option value='-1'>All</option>
            <option value="{{month.date}}" *ngFor="let month of monthSubFilterOptions">{{month.date}}</option>
          </select>
        </span>
        <span class="cb-cell">
          <app-auto-complete (ngModelChange)="panchangFilter($event,'year')" [settings]="autoCompleteSettings"
            [(ngModel)]="varsham" [ngModelOptions]="{standalone: true}" [options]="allMonths"></app-auto-complete>
        </span>
        <span class="cb-cell">
          <app-auto-complete (ngModelChange)="panchangFilter($event,'nakshathra')" [settings]="autoCompleteSettings"
            [(ngModel)]="star" [ngModelOptions]="{standalone: true}" [options]="allNakshathram"></app-auto-complete>
        </span>
        <span class="cb-cell">
          <app-auto-complete (ngModelChange)="panchangFilter($event,'thithi')" [settings]="autoCompleteSettings"
            [(ngModel)]="thidhi" [ngModelOptions]="{standalone: true}" [options]="allThithi"></app-auto-complete>
        </span>
        <span class="cb-cell">
          <app-auto-complete (ngModelChange)="panchangFilter($event,'week');$event!==week&&setWeekFilterOptions($event)" [settings]="autoCompleteSettings"
            [(ngModel)]="week" [ngModelOptions]="{standalone: true}" [options]="allWeek"></app-auto-complete>
          <select *ngIf="!!isWeekFilter" [(ngModel)]="weekOption" [ngModelOptions]="{standalone: true}"
            class="form-select form-select-sm" (change)="panchangFilter(week,'week')">
            <option value="0">All</option>
            <option value="{{weekF.id}}" *ngFor="let weekF of weekFilterOptions">{{weekF.name+week}}</option>
          </select>
        </span>
      </div>

      <cdk-virtual-scroll-viewport itemSize="44" class="cdk-viewport">
        <div class="cb-row cb-body-row" *cdkVirtualFor="let p of displaypanEvents;trackBy:trackByFn;let i=index">
          <span class="cb-cell cb-check">
            <span class="form-check" (click)="$event.stopPropagation()">
              <input class="form-check-input" type="checkbox" [checked]="p.selected===true" (click)="select(p)">
            </span>
          </span>
          <span class="cb-cell">{{p.date|dateFormatter }}</span>
          <span class="cb-cell">{{p|pconvert:'year'}}</span>
          <!-- Star/Thithi can carry a second name (two-star/two-thithi days) —
               wrap to two lines like the legacy table instead of clipping. -->
          <span class="cb-cell cb-wrap">{{p|pconvert:'nakshathra'}}</span>
          <span class="cb-cell cb-wrap">{{p|pconvert:'thithi'}}</span>
          <span class="cb-cell">{{p|pconvert:'week'}}</span>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

  </form>
</div>